import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Autocomplete, AutocompleteProps, Paper, Box, Checkbox, FormControlLabel, Divider } from '@mui/material'

interface AutocompleteWithSelectAllProps<T> extends AutocompleteProps<T, true, any, false, any> {
  setValue: (value: T[]) => void
  checkboxId?: string
}

export default function AutocompleteWithSelectAllMixin<T>(props: AutocompleteWithSelectAllProps<T>) {
  const { setValue, onChange, ...autocompleteProps } = props
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const { t } = useTranslation(['reports-management'])

  const handleSelectAll = () => {
    setSelectAll((prev) => {
      if (!prev) setValue([...props.options])
      else setValue([])
      return !prev
    })
  }

  return (
    <Autocomplete
      {...autocompleteProps}
      noOptionsText={t('modals.paymentsHistory.options.notFound').toUpperCase()}
      onChange={(_e, value, reason, details) => {
        if (reason === 'clear' || reason === 'removeOption') setSelectAll(false)
        if (reason === 'selectOption' && value.length === props.options.length) setSelectAll(true)
        setValue(value)

        if (onChange !== undefined) onChange(_e, value, reason, details)
      }}
      PaperComponent={(paperProps) => {
        const { children, ...restPaperProps } = paperProps
        return (
          <Paper {...restPaperProps}>
            <Box
              onMouseDown={(e) => e.preventDefault()} // prevent blur
              pl={1.5}
              py={0.5}
            >
              <FormControlLabel
                label={t('modals.paymentsHistory.options.selectAll').toUpperCase()}
                onClick={(e) => {
                  e.preventDefault() // prevent blur
                  handleSelectAll()
                }}
                control={
                  <Checkbox
                    checked={selectAll}
                    sx={{
                      '& .MuiSvgIcon-root': { fill: '#15B79E' }
                    }}
                    id={props.checkboxId ?? `select-all-checkbox-for-autocomplete-${props.id}}`}
                  />
                }
              />
            </Box>
            <Divider />
            {children}
          </Paper>
        )
      }}
    />
  )
}
